import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Container,CssBaseline,
    Grid,Button,Paper } from '@material-ui/core';
import omit from 'lodash/omit';
// import moment from 'moment';
import { useHistory,useParams,useLocation } from 'react-router-dom';

import { AppContext } from '../../App';
import axios from '../../utils/axios';
import util from '../../utils/util';

import validate from '../../utils/validate';
import constraint from '../../Constraints/Vehicule';
import MyTextField from '../Codification/MyTextField';
import MyDateField from '../Codification/MyDateField';
import MySelectField from '../Codification/MySelectField';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }, 
}))
const initData = {
    date_vehicule:"",
    source_vehicule:"",
    errors:{}
};
export default function Vehicule(){
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams()
    const appContext = React.useContext(AppContext);
    const [vehicule,setVehicule] = React.useState({...initData})
    const [modeles,setModeles] = React.useState([])
    const [carburants,setCarburants] = React.useState([])
    const [view,setView] = React.useState(false);
    const { pathname } = useLocation();
    const fetchData = async ()=>{
        appContext.setOpenLoading(true);
        try {
            const [modeles,carburants] = await Promise.all([
                axios.get(`/modeles`),
                axios.get(`/carburants`),
            ]);
            if(id){
                const {data} = await axios.get(`/vehicules/${id}`);
                let vehicule = {
                        id: data.id,
                        date_achat:data.date_achat,
                        modele:data.modele.id,
                        carburant:data.carburant.id,
                        prix_achat:data.prix_achat,
                        immatriculation: data.immatriculation,
                        numero_chassis: data.numero_chassis,
                        nbre_km_achat: data.nbre_km_achat,
                        errors:{}
                    }
                if(pathname===`/vehicules/view/${id}`){
                    console.log(data)
                    setView(true);
                    vehicule = {
                        ...vehicule,
                        modele:data.modele,
                        carburant:data.carburant
                    }
                }
                setVehicule(vehicule)
            }
            setModeles(modeles.data.results)            
            setCarburants(carburants.data.results)            
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }
        appContext.setOpenLoading(false);
    }

    React.useEffect(()=>{
        fetchData();
        // eslint-disable-next-line
    },[]);
    const handleChange = (e)=>{
        setVehicule({...vehicule,[e.target.name]:e.target.value})
    }
    const enregistrer = async (nouveau)=>{
        const errors = validate(vehicule,constraint.add);
        if(errors){
            setVehicule({...vehicule,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.post(`/vehicules`,{...omit(vehicule,['errors','prestataire'])});
            appContext.addMessage('Enregistrement effectué avec succès','success');
            if(nouveau){
                setVehicule({...initData})
            }else{
                history.push("/liste-vehicules")
            }
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    const modifier = async ()=>{
        const errors = validate(vehicule,constraint.add);
        if(errors){
            setVehicule({...vehicule,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.put(`/vehicules/${vehicule.id}`,{...omit(vehicule,['errors'])});
            appContext.addMessage('Modification effectué avec succès','success');
            history.goBack()
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Paper className={classes.paper}>

                <Typography variant="h5" gutterBottom>
                    {id ? "Modification" : "Saisie"} Vehicule
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <MyDateField 
                            name="date_achat"
                            value={vehicule.date_achat||""}
                            onChange={handleChange}
                            errors={vehicule.errors}
                            label="Date achat"
                            disabled={view}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="modele"
                                value={vehicule.modele && vehicule.modele.nom}
                                label="Modele"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="modele"
                                value={vehicule.modele}
                                onChange={handleChange}
                                errors={vehicule.errors}
                                options={modeles}
                                libelle="nom"
                                disabled={view}
                                label="Modele"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="carburant"
                                value={vehicule.carburant && vehicule.carburant.libelle}
                                label="Carburant"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="carburant"
                                value={vehicule.carburant}
                                onChange={handleChange}
                                errors={vehicule.errors}
                                options={carburants}
                                libelle="libelle"
                                disabled={view}
                                label="Carburant"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            name="immatriculation"
                            value={vehicule.immatriculation}
                            onChange={handleChange}
                            errors={vehicule.errors}
                            label="Immatriculation"
                            variant="outlined"
                            disabled={view}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            name="numero_chassis"
                            value={vehicule.numero_chassis}
                            onChange={handleChange}
                            errors={vehicule.errors}
                            label="N° Chassis"
                            variant="outlined"
                            disabled={view}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                                style:{textAlign:'right'}
                            }}
                            name="prix_achat"
                            type={view?"text":"number"}
                            value={view ? util.separteurMillier(vehicule.prix_achat):vehicule.prix_achat}
                            onChange={handleChange}
                            errors={vehicule.errors}
                            label="Prix d'achat"
                            disabled={view}
                            // style={{}}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                                style:{textAlign:'right'}
                            }}
                            name="nbre_km_achat"
                            type={view?"text":"number"}
                            value={view ? util.separteurMillier(vehicule.nbre_km_achat):vehicule.nbre_km_achat}
                            onChange={handleChange}
                            errors={vehicule.errors}
                            label="Km achat"
                            disabled={view}
                            // style={{}}
                        />
                    </Grid>
                    {id ?
                        <Grid item xs={12} sm={12}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={view?history.goBack:modifier}
                            >
                                {view ?'Retour':'Modifier'}
                            </Button>
                        </Grid>
                        :
                        <Grid container>
                            <Grid item xs={6} sm={6} style={{display:'flex', justifyContent:'center'}}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(true)}
                                >
                                    Enregistrer & Nouveau
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(false)}
                                >
                                    Enregistrer & Quitter
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Paper>
        </Container>
    )
};